import SiteLayout from "@/components/feature/SiteLayout";
import PageHero from "@/components/base/PageHero";
import SectionDivider from "@/components/base/SectionDivider";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import AboutMission from "@/pages/about/components/AboutMission";
import AboutApproach from "@/pages/about/components/AboutApproach";
import AboutTechnology from "@/pages/about/components/AboutTechnology";
import AboutReasons from "@/pages/about/components/AboutReasons";
import AboutPrinciples from "@/pages/about/components/AboutPrinciples";
import AboutLocation from "@/pages/about/components/AboutLocation";
import AboutStats from "@/pages/about/components/AboutStats";
import CtaSection from "@/pages/home/components/CtaSection";

export default function About() {
  useDocumentMeta({
    title: "Hakkımızda | d.mar Dental Görüntüleme Merkezi",
    description:
      "d.mar Dental Görüntüleme Merkezi: İstanbul Şişli/Osmanbey'de dental radyolojiye adanmış merkez. Modern dijital cihazlar, deneyimli kadro ve aynı gün dijital rapor.",
    path: "/hakkimizda",
  });

  return (
    <SiteLayout>
      <PageHero
        crumb="Hakkımızda"
        eyebrow="Biz Kimiz?"
        title="İstanbul'da dental radyolojiye adanmış bir merkez"
        description="d.mar Dental Görüntüleme Merkezi; diş hekimlerinin tedavi planlaması için ihtiyaç duyduğu tüm dental radyoloji hizmetlerini modern dijital cihazlarla, uzman kadrosuyla ve aynı gün rapor prensibiyle sunan bağımsız bir görüntüleme merkezidir."
      />
      <AboutMission />
      <SectionDivider />
      <AboutApproach />
      <SectionDivider />
      <AboutTechnology />
      <SectionDivider />
      <AboutReasons />
      <SectionDivider />
      <AboutPrinciples />
      <SectionDivider />
      <AboutLocation />
      <SectionDivider />
      <AboutStats />
      <CtaSection />
    </SiteLayout>
  );
}